import React, { useState } from 'react';
import '../index.scss';
import '../home.scss';
import tight1664logo from '../assets/logo/tight1664logo.png';
import Register from './Register';
import Login from './Login';


function Home() {
  const [formType, setFormType] = useState("login");

  return (
    <div className="homepage">
     
      <div className="grid-left">
      <img src={tight1664logo} alt="1664 Logo" />
      <h1 style={{fontSize: "2rem"}}>WELCOME TO THE <br></br>1664 PRACTITIONER PORTAL</h1>
      </div>

      <div className="grid-right">
        {formType === "register" ? (
          <Register switchToLogin={() => setFormType("login")} />) : (
          <Login switchToRegister={() => setFormType("register")} />)}
      </div>
    </div>
  )
}

export default Home